import { FC, PropsWithChildren, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ConflictsNav, ExpandedAdornment } from "@ryde/controls";

import { GenericUploadRowConflictsContext } from "../../contexts";

type IRowConflictsExpandedProps = PropsWithChildren;

export const RowConflictsExpanded: FC<IRowConflictsExpandedProps> = ({
  children,
}) => {
  const { t } = useTranslation();
  const { conflicts } = useContext(GenericUploadRowConflictsContext);

  return (
    <ExpandedAdornment
      NavControl={
        <ConflictsNav
          title={t(`genericUpload.conflicts.${conflicts?.at(0)?.errorType}`)}
          severity={conflicts?.at(0)?.errorSeverity}
          conflictNumber={conflicts?.length ?? 0}
        />
      }
    >
      {children}
    </ExpandedAdornment>
  );
};
